import * as React from "react";

import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";

import { Loading } from "../Common";
import { getConfigObject } from "../../fwptools";

import UserDelegate from "./utilities/UserDelegate.js";

const SecurityContext = React.createContext(null);

const auth0Configuration = {
    authorizationParams: {
        redirect_uri: window.location.origin
    },
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    useRefreshTokens: false // change to true
};

let logInInterval = null;
let userDelegate = null;

export const loggedIn = new Promise(resolve => {
    logInInterval = setInterval(() => {
        if (userDelegate !== null) {
            clearInterval(logInInterval);
            resolve(userDelegate);
        }
    }, 1000);
});

export const useLoggedIn = () => {
    return React.useContext(SecurityContext);
};

export const SecurityProvider = () => {
    const navigate = useNavigate();

    const onRedirect = (appState) => {
        console.log(`appstate: ${appState}`);
        navigate((appState && appState.returnTo) || window.location.pathname);
    };

    return (
        <Auth0Provider {...auth0Configuration} onRedirectCallback={onRedirect}>
            <Security/>
        </Auth0Provider>
    );
};

const Security = (props) => {
    const config = getConfigObject(useLocation().pathname);
    const { isAuthenticated, isLoading, user, loginWithRedirect } = useAuth0();

    if (isLoading) {
        return <Loading/>;
    }

    if (!isAuthenticated) {
        loginWithRedirect().then();
        return null;
    }

    userDelegate = new UserDelegate(user, () => isAuthenticated);

    return (
        <SecurityContext.Provider value={{ config: config, user: userDelegate }}>
            <Outlet/>
        </SecurityContext.Provider>
    );
};